import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { redirectToCenter } from "@/utils/center";
import { useEffect } from "react";

/**
 * Login bridge page.
 *
 * The admin app has no local login form — authentication is delegated to
 * irohana-center (SSO). This page is the single place that knows where center
 * lives: it stashes the intended destination (so it can be restored after the
 * SSO round-trip via `/auth/callback`) and forwards the user to center.
 */
const Login = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirectUrl = params.get("redirectUrl");
    if (redirectUrl) {
      sessionStorage.setItem("post-login-redirect", redirectUrl);
    }

    redirectToCenter({ replace: true });
  }, []);

  return <LoadingScreen />;
};

export default Login;
